import { PageUtils } from "./helpers/page-utils";

window.addEventListener('load', () => {
    // Check if there's a fragment identifier (#id) in the URL
    const hash = window.location.hash.split('?')[0]; // Removes query parameters if present

    if (hash) {
        const cleanId = hash.startsWith('#') ? hash.slice(1) : hash;

        const targetElement = document.getElementById(cleanId);
        if (targetElement) {
            PageUtils.scrollToTarget(targetElement);
        }
    }

    // Add smooth scrolling to buttons with data-destination attribute
    document.querySelectorAll('button[data-destination]').forEach((scrollButton) => {
        const destination = scrollButton.dataset.destination;
        const cleanId = destination.startsWith('#') ? destination.slice(1) : destination;

        const targetElement = document.getElementById(cleanId);

        if (targetElement) {
            scrollButton.addEventListener('click', () => {
                // Use the same smooth scroll logic to scroll to the target element
                PageUtils.scrollToTarget(targetElement);
            });
        }
    });
});
